import { SystemIcons } from '@almbrand/systemicons';
import { useDesignSystemThemeName } from 'hooks/useDesignSystemThemeName';
import styles from './ExportCsvButton.module.scss';

interface ExportCsvButtonProps {
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	title?: string; // Optional tooltip
	disabled?: boolean;
}

export const ExportCsvButton: React.FC<ExportCsvButtonProps> = ({ onClick, title = 'Eksporter CSV', disabled }) => {
	const themeName = useDesignSystemThemeName();

	return (
		<button
			className={styles.ExportCsvButton__button}
			onClick={onClick}
			title={title}
			disabled={disabled}
			type='button'
		>
			<span className={styles.ExportCsvButton__icon}>
				<SystemIcons
					themeName={themeName}
					icon={'download'}
					width={'100%'}
					height={'100%'}
				/>
			</span>
		</button>
	);
};
